export { default } from './Col1Text'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col1Text/index.js